import {postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import type {JsonValues} from "../../form/translate/to_json_values";
import {IUserProfile} from "../../user/types/IUserProfile";

const emailSignInApiLink = apiLink.user.login({});

export const emailSignIn = (jsonData: JsonValues): Promise<IUserProfile> => {
    return postRequest({}, emailSignInApiLink(null), jsonData);
};
import {postRequest} from "@pg-mono/request";
import {apiLink} from "@pg-mono/rp-api-routes";

import type {JsonValues} from "../../form/translate/to_json_values";
import {IUserProfile} from "../../user/types/IUserProfile";

const emailSignInApiLink = apiLink.user.login({});

export const emailSignIn = (jsonData: JsonValues): Promise<IUserProfile> => {
    return postRequest({}, emailSignInApiLink(null), jsonData);
};
